module.exports = __webpack_public_path__ + "media/images/field-plus-47a939ca.png";